module.exports = {
  common: {
    instagramLink: "https://www.instagram.com/hk_marketplace/",
    facebookLink: "https://www.facebook.com/marketplacehongkong",
    youtubeLink: "https://www.youtube.com/channel/UCbZNuy8dP-66eD1nY-4B5Xg",
    wellCenter: "Market Place 網購客戶幫助中心",
    searchPlaceholder: "在 Market Place 搜尋"
  },
  footer: {
    aboutShop: "關於 Market Place",
    followUs: "關注我們",
    coptyRight: "© 2024 Wellcome / Market Place. The Dairy Farm Company Limited. All rights reserved.",
    ourStory: "關於 Market Place",
    ourStoryLink: "https://www.marketplacehk.com/zh-hant/d/SwxfFYOJm0tPzR.html",
    corporateResponsibility: "社區關注",
    corporateResponsibilityLink: "https://www.marketplacebyjasons.com/zh/community",
    storeLocatorLink: "/zh-hant/store_locator",
    careersLink: "https://joinus.dfiretailgroup.com/jobs/search",
    corporatePromotionsLink: "https://www.marketplacebyjasons.com/zh/stamp-programme",
    foodPermitsLink: "/dl/All_Marketplacehk.com_2024.pdf",
    foodPermitsName: "Market Place license.pdf",
    tel: "+852 3001 1299",
    emailLink: "cs@marketplacebyjasons.com",
    privacyPolicyLink: "https://www.marketplacebyjasons.com/zh/privacy-policy",
    termsAndConditionsLink: "https://www.marketplacehk.com/zh-hant/d/hcDR1FBqZ4.html",
    wellcomeWhatsAppTermsAndConditions: "Market Place WhatsApp 條款及細則",
    regardHreesixty: "關於3hreesixty",
    regardHreesixtyLink: "https://www.marketplacehk.com/zh-hant/d/rQkyELZn3KPlAmzS.html",
    wellcomeWhatsAppTermsAndConditionsLink: "https://www.marketplacebyjasons.com/zh/node/431",
    contactUsLink: "https://www.marketplacebyjasons.com/index.php/zh/contact-us",
    download: "品味超市 一APP到手",
    appStoreLink: "https://apps.apple.com/us/app/market-place-online-shop/id1513522092",
    goolePlayLink: "https://play.google.com/store/apps/details?id=com.rtasia.intl&hl=en&gl=US",
    emailBulkorderLink: "Business@marketplacehk.com",
    b2bBulkOrdersEnquires: "企業合作及大量訂購查詢"
  },
  page: {
    siteName: "Market Place",
    siteUrl: "https://www.marketplacehk.com",
    title: "Market Place 網店",
    description:
      "Market Place 為你搜羅環球優質食材百貨及美酒，帶來源源不絕的美食創作靈感，滿足你對美食的熱忱。購物滿$500即免費送貨，滿$150更享免費門市取貨服務。"
  },
  pageTitle: {
    cart: "購物車 | Market Place Online Shop",
    checkout: "安全結賬 | Market Place Online Shop",
    cards: "電子銀包 | Market Place Online Shop",
    coupons: "優惠券 | Market Place Online Shop",
    order_list: "我的訂單 | Market Place Online Shop",
    order_details: "訂單詳情 | Market Place Online Shop",
    cashier: "收銀台 | Market Place Online Shop",
    payment: "支付成功 | Market Place Online Shop",
    categoryName: "{name} | Market Place Online Shop",
    storeLocator: "門店查詢 | Market Place Online Shop"
  },
  productDetails: {
    freshnessInfo: "Market Place致力確保此保鮮產品保質期至少為{num}日，包括送貨當日。"
  },
  order: {
    banner: "所有訂單都從您的 Market Place app 同步。有些訂單可能會被拆分，但我們會在每次購買時一併送貨。",
    syncedOrder: "這是 Market Place app 同步過來的訂單。",
    goToAppTips: "請前往Market Place應用程式查看更多明細"
  },
  orderDetails: {
    productdisabledTitle: "請在Market Place app查看商品詳情"
  },
  cart: {
    rangeStandardDeliveryTitle: "以下商品無法送達，請前往Market Place應用程式享受完整體驗",
    unRangeStoreGroupTitle: "以下商品無法使用“極速送貨”或“精選預訂”，請前往Market Place應用程式享受完整體驗",
    slaveStoreMsg: "您在Market Place app其他商店選購的商品已同步，現可於惠康網站一起結帳",
    slaveStoreTip: "請在Market Place app查看商品詳情"
  },
  getTheApp: {
    title: "Market Place app 讓惠康手機網購更簡單、輕鬆、快捷！ ",
    description: "立即打開 Market Place 網購，挑選心儀的商品吧！",
    goTo: "打開 Market Place"
  },
  header: {
    feedbackLink: "https://yuu.qualtrics.com/jfe/form/SV_8erEI4Mn8qdgDps",
    customerCareLink: "https://www.marketplacebyjasons.com/zh/contact-us"
  }
}
